import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import color from 'color'
import {theme} from '../../../../../../../../utils/theme'
export default({scholarship})=>{
  return(

<Card style={{backgroundColor:color("#2196f3").lighten(0.7 ),padding:20}}>
        <CardContent  style={{padding:0}}>
           <Typography variant="h5">
            Scholarship
          </Typography>
		  <br/> <br/>
         <Typography  variant="h4" style={{color:"#000000"}}>
          {scholarship}%
          </Typography>
        </CardContent>

      </Card>
    )
  }
